<template>
    <div class="biz-map-search">
        <share-social-media :cid="seletedHouseCid"></share-social-media>
        <div class="biz-map-search-left">
            <map-house-menu></map-house-menu>
        </div>
        <div class="biz-map-search-right" >
            <map-search-filter></map-search-filter>
            <map-content ></map-content>
        </div>
    
    </div>
</template>
<script>
import MapHouseMenu from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapHouseMenu.vue';
import MapSearchFilter from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapSearchFilter.vue';
import MapContent from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapContent.vue';
import shareSocialMedia from '@/components/bussiness/widges/modals/shareSocialMedia.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent('房源管理_地圖模式', { screen_name: '房源管理_地圖模式'})
        this.$store.dispatch('setBizHouseMgtMode', 'map')
        this.$store.dispatch('getBizHouseMgtList')
    },
    computed: {
        ...mapGetters({
            seletedHouseCid: 'GET_BIZ_HOUSE_SELECT_CID'
        })
    },
    components: {
        MapHouseMenu,
        MapSearchFilter,
        MapContent,
        shareSocialMedia
    }
}
</script>
<style lang="scss" scoped>
    // body #app {
    //     width: 1920px !important;
    // }
    .biz-map-search{
        position: relative;
        display: flex;
        min-width: 1280px;
        .biz-map-search-left{
            width: 27.77%;
            padding: 20px 0px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            background-color: #ffffff;
            z-index: 2;
            display: flex;
            align-items: flex-start;
            justify-content: flex-end;
        }
        .biz-map-search-right{
            width: 72.23%;
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-map-search{
            .biz-map-search-left{
                width: 27.77%;
            }
            .biz-map-search-right{
                width: 72.23%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/mapSearch.vue